<script>
// import gsap from 'gsap'
// import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin'
// import { MotionPathPlugin } from 'gsap/MotionPathPlugin'

// gsap.registerPlugin(DrawSVGPlugin, MotionPathPlugin)

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    popContent: {
      type: String,
      default: '',
    },
    popColor: {
      type: String,
      default: '',
    },
    popSize: {
      type: String,
      default: '',
    },
    popHeight: {
      type: String,
      default: '',
    },
    posX: {
      type: Number,
      default: 0,
    },
    posY: {
      type: Number,
      default: 0,
    },
    posUnit: {
      type: String,
      default: 'px',
    },
  },
  data() {
    return {}
  },
  computed: {
    popStyle() {
      return {
        top: this.posY + this.posUnit,
        left: this.posX + this.posUnit,
        height: this.popHeight,
      }
    },
  },
  mounted: function() {
    // this.gsapTest()
  },
  methods: {
    getPopID(title) {
      return 'pop-' + this.title
    },
    isPlaced() {
      if (this.posX > 0 || this.posY > 0) {
        return 'placed'
      } else {
        return 'notPlaced'
      }
    },
    gsapTest() {
      /* gsap.to(".pop-border", {rotation: 27, x: 100, duration: 1}); */
      /*

      gsap.registerPlugin(MotionPathPlugin, DrawSVGPlugin);

      const noTrailParts = 10;
      let trailParts = '';
      const distance = 0.03;


// create trail ============
      for(let i=0; i<noTrailParts; i++){
        const trail = document.createElement('div');
        trail.classList.add("trail");
        document.body.appendChild(trail);

        // decreasing transparency
        gsap.set(trail,{backgroundColor:'rgba(255,195,173,'+(noTrailParts-i)*distance +')'});
        // decreasing height
        gsap.set(trail,{scale:1 - (i/(noTrailParts+20)), transformOrigin:'center'});

        trailParts = document.querySelectorAll('.trail')
      }

      gsap.set(trailParts, {xPercent: -50, yPercent: -50, transformOrigin: "50% 50%"});

      // move trailParts along the path with a certain gap = delay
      for(let i = 0; i < trailParts.length; i++) {
        const delay = (i * distance);

        gsap.to(trailParts[i], {motionPath:{
            path:'.pop-border-path',
            align: "self",
            autoRotate: true,
            offsetY:20, offsetX: 20
          }, duration:10, ease:"none", repeat:-1, delay:delay})
      }

       */
    },
  },
}
</script>

<template>
  <div class="popWrapper">
    <div
      id="pop-test"
      :class="['popOver', 'pop' + popSize, popColor]"
      :style="popStyle"
    >
      <slot />
    </div>
    <svg
      class="pop-border"
      :class="['pop-border', 'pop-' + popSize]"
      :height="popHeight"
      :style="popStyle"
    >
      <rect
        class="pop-border-path"
        x="0"
        y="0"
        :style="{ height: popHeight }"
      />
    </svg>
  </div>
</template>

<style lang="scss">
.popOver {
  position: absolute;
  z-index: 5;
  padding: 1.5rem;
  background: rgba(5, 30, 47, 0.75);
  filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.8));
  border: solid 1px #fff;
  clip-path: polygon(
    0% 0,
    0 0%,
    0 0%,
    100% 0,
    100% calc(100% - 30px),
    calc(100% - 30px) 100%,
    0 100%,
    0 0
  );

  &.placed {
    position: absolute;
    z-index: 15;
  }

  &.poplg {
    width: 600px;
  }

  &.popmd {
    width: 400px;
  }

  &.popsm {
    width: 200px;
  }
  &.white {
    text-shadow: 2px 3px 5px rgba(0, 0, 0, 0.8);
    background-color: rgba(255, 255, 255, 0.1) !important;
  }
}

.popBorder {
  position: absolute;
  z-index: 10;

  .popBorderPath {
    width: 100%;
    fill: transparent;
    stroke: #fff;
    stroke-width: 2px;
  }

  &.poplg {
    width: 600px;
  }

  &.popmd {
    width: 400px;
  }

  &.popsm {
    width: 200px;
  }
}
</style>
